import { COLOR } from '@src/styles/color';
import { MOBILE_BREAKPOINT } from '@src/styles/config';
import { Card } from '@mui/material';
import styled from 'styled-components';

export const StyledNewPackageFreeRowItem = styled(Card)`
  .free-amount-credits {
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.4px;
    justify-content: space-between;
    .free-amount-credits-item {
      display: flex;
      align-items: center;
      color: ${COLOR.darkGray};
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: -0.4px;
    }
    .info-out-line-icon {
      font-size: 14px;
      color: #1e164ea3;
    }
    .fiber-manual-record-icon {
      color: #1e164ea3;
      font-size: 10px;
      margin-right: 10px;
    }
  }

  .purchase-amount-credits {
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.4px;
    margin-bottom: 8px;
    .fiber-manual-record-icon {
      color: #1e164ea3;
      font-size: 10px;
      margin-right: 10px;
      margin-bottom: 1px;
    }
  }

  .card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }
  .flexItem {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .tooltip {
    color: ${COLOR.tooltipColor};
    svg {
      width: 16px;
      height: 16px;
    }
  }
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: ${(props) => props.chosenPackage && '#FFFCEC'};
  border: 0.5px solid rgba(30, 22, 78, 0.16);
  overflow: visible;
  padding: ${(props) => (props.isRow ? '40px 48px' : '21px 13px 13px 13px')};
  border-radius: 24px;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.08);
  .package-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    max-height: 60px;
    .MuiTypography-root {
      line-height: 1;
    }
  }

  .name-content {
    display: flex;
    align-items: center;
    gap: 0 4px 0 0;
  }

  .package-name {
    font-size: 20px;
    font-weight: bold;
    color: ${COLOR.darkGray};
  }

  .package-name-row {
    font-size: 32px;
    font-weight: 700;
    color: ${COLOR.darkGray};
  }

  .price-package {
    display: flex;
    align-items: center;
    letter-spacing: -1.4px;
  }

  .price-wrapper {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: ${(props) => (props.isMobile || props.isRow ? '0px' : '24px')};
  }

  .original-price-wrapper {
    display: flex;
    align-items: center;
    height: 20px;
  }
  .original-custom-price-wrapper {
    display: flex;
    align-items: center;
    height: 20px;
    gap: 6px;
  }

  .price-original-discount {
    padding-top: 2px;
    .discount-unit-price {
      font-size: 12px;
      font-weight: 400;
      line-height: 24px;
      color: ${COLOR.lightText};
      text-transform: lowercase;
      padding-bottom: -2px;
    }
  }

  .original-price,
  .original-price-not-line-through {
    font-size: 14px;
    font-weight: 400;
    line-height: 32px;
    white-space: nowrap;
    color: ${COLOR.lightText};
  }

  .original-price-not-line-through {
    text-decoration: none;
    margin-left: -6px;
  }

  .price-en {
  }

  .original-card {
    min-height: 52px;
  }

  .price {
    font-size: 32px;
    letter-spacing: 0;
    font-weight: 800;
    white-space: nowrap;
    color: ${COLOR.darkBlue};
    display: flex;
    align-items: center;
  }

  .three-first {
    font-size: 32px;
    font-weight: 800;
  }

  .three-last {
    font-size: 16px;
    font-weight: 700;
  }

  .unit-price {
    font-weight: 510;
    font-size: 16px;
    line-height: 24px;
    color: ${COLOR.darkBlue};
    text-transform: lowercase;
    padding-bottom: -2px;
  }

  .sub-price {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    margin-left: 6px;
    color: ${COLOR.black[64]};
  }

  .original-price {
    font-size: 14px;
    font-weight: 700;
    white-space: nowrap;
    color: ${COLOR.lightText};
  }

  .original-price-month {
    font-size: 14px;
    white-space: nowrap;
    text-decoration: line-through;
    color: ${COLOR.lightText};
  }

  .original-price-unit {
    font-size: 12px;
    font-weight: 700;
    color: ${COLOR.lightText};
  }

  .font-size-14 {
    font-size: 14px !important;
  }

  .font-size-16 {
    font-size: 16px !important;
  }

  .underlined {
    text-decoration: underline;
  }

  .sub-origin-price {
    font-size: 14px;
    font-weight: 400;
    color: ${COLOR.lightText};
    margin-left: 4px;
  }

  .button-start {
    font-weight: bold;
    margin-top: ${(props) => (props.isRow ? '16px' : '24px')};
    border-radius: ${(props) =>
      props.highlight && props.isPoppular ? '12px 12px 0px 0px' : '12px'};
    opacity: ${(props) => (props.isDisableButton ? '0.5' : '1')};
    border-color: ${COLOR.darkBlue};
    color: ${COLOR.darkBlue};
    text-transform: none;
    height: 48px;
    padding: 8px 16px;
    box-sizing: border-box;
    pointer-events: ${(props) => props.isDisableButton && 'none'};
  }

  .free-package-button {
    height: 78px;
  }

  .text-limited {
    margin: 6px 0px 3px 0px;
    color: ${COLOR.lightText};
  }

  .icon-contents {
    margin-left: -16px;
    margin-right: 5px;
    .dots {
      color: #1e164ea3;
      font-size: 10px;
      margin-right: 5px;
    }
  }
  .title-text {
    color: #1c1c1e;
    font-weight: 700;
    margin-top: 14px;
    font-size: 14px;
  }
  .clarify {
    margin-bottom: 6px;
    opacity: 1 !important;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 16px;
    padding-right: 0;
    .coming-soon-text {
      width: 100% !important;
    }
    .coming-soon-text-advanced {
      color: #5856d6 !important;
      font-weight: 700;
    }
    .coming-soon-title {
      color: #1c1c1ea3;
      font-size: 14px;
      margin-left: 5px;
      font-weight: 400;
    }
    .item-package {
      width: 100%;
      display: flex;
      word-wrap: break-word;
      align-items: center;
      .content {
        color: #1c1c1e;
      }
    }
  }
  .package-content-item {
    margin-bottom: ${(props) => (props.isRow ? '0px' : '8px')};
  }

  .tooltip {
    display: flex;
    align-items: center;
  }
  .note {
    font-style: italic;
    font-size: 14px;
    color: #1c1c1ea3;
  }
  .disabled-content {
    color: ${COLOR.red};
  }

  .content {
    color: #1c1c1e;
    strong {
      color: ${COLOR.darkGray};
    }
    font-size: 14px;
    p {
      margin: 0;
    }
  }

  .content-deactivate {
    color: ${COLOR.light};
    font-size: 14px;
  }

  .btn-view-more-container {
    display: flex;
    justify-content: center;

    padding: 5px;
  }

  .description-package {
    color: ${COLOR.label2['64']};
    font-weight: 400;
    font-size: 14px;
    height: 42px;
    letter-spacing: -0.4;
  }

  .package-free-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    gap: 40px;
    padding: 0px 24px;
    .package-free-header {
      flex: 8;
      .list-package-content {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 2px;
        padding: 0px;
        .free-amount-credits {
          display: flex;
          align-items: center;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: -0.4px;
          justify-content: space-between;
          .free-amount-credits-item {
            display: flex;
            align-items: center;
            color: ${COLOR.darkGray};
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            letter-spacing: -0.4px;
          }
          .info-out-line-icon {
            font-size: 14px;
            color: #1e164ea3;
          }
          .fiber-manual-record-icon {
            color: #1e164ea3;
            font-size: 10px;
            margin-right: 10px;
          }
        }
      }
    }
    .card-content-free {
      flex: 8;
      padding-top: 16px;
      .list-package-content-free {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 2px;
      }
    }
    .price-free-row {
      flex: 5;
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    overflow: ${(props) => (props.mostpopular ? 'hidden' : 'visible')};

    .chip-none {
      height: 0px;
    }

    .card-info {
      margin-top: 0px !important;
    }
  }
`;
